// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1OEQC","col":"CardReaderDesc_col__33v3p","label":"CardReaderDesc_label__3BS9k"};